<template>
  <div>
    <!-- Main  -->
    <section class="hero-bg h-auto">
      <section class="h-screen" id="main">
          <div class="flex flex-col justify-center items-center pt-36 md:pt-80 lg:pt-20 2xl:pt-28 font-oxanium">
              <div>
                <img src="../assets/chillislots-logo.png" class="max-w-[350px] md:max-w-[600px] lg:max-w-[600px] 2xl:max-w-[700px]">
              </div>
              <div class="md:-mt-32 lg:-mt-60 2xl:-mt-[300px] hidden md:block">
                <img src="../assets/chillislots-caution-banner.png" class="max-h-[600px]">
              </div>
              <div class="-mt-10 block md:hidden">
                <img src="../assets/chilislots-caution-mobile-banner.png" class="max-h-[600px]">
              </div>
              <div class="flex flex-col md:flex-row gap-4 mt-4 md:-mt-8 lg:-mt-32 2xl:-mt-40 px-8">
                <a href="https://t.co/Z7heAbXfcM" target="_blank">
                  <button v-motion-pop-visible class="text-white font-bold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border border-white hover:border-[#E64435] hover:text-white font-base py-5 px-[40px] relative uppercase rounded-xl">
                    REGISTER ON ROOBET.COM
                  </button>
                </a>
                <a href="https://t.co/uMJCRXf7uw" target="_blank">
                  <button v-motion-pop-visible class="text-white font-bold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border border-white hover:border-[#E64435] hover:text-white font-base py-5 px-[30px] md:px-[36px] relative uppercase rounded-xl">
                    WATCH LIVE STREAM ON KICK
                  </button>
                </a>
              </div>
          </div>
      </section>
      <!-- Raffle Section -->
      <section class="h-auto px-6 py-14 md:px-6 lg:px-36 2xl:px-[340px] pt-24 md:pt-20 lg:py-40 promotion-bg" id="promotions">
        <div class="flex flex-col justify-center items-center font-montserrat">
            <p v-motion-pop-visible class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-4xl uppercase">MY Promotions</p>
          </div>
        <div class="flex flex-wrap justify-center items-center mt-12 gap-6">
          <div v-motion-pop-visible class="w-full md:w-[48%] lg:w-[30%] shadow-red-600 shadow-2xl rounded-2xl">
            <div class="relative roobet-small-bg h-[320px] md:h-[400px] rounded-2xl">
              <div class="absolute bottom-0 w-full px-6 pb-6">
                <a href="https://t.co/Z7heAbXfcM" target="_blank">
                  <button class="text-white w-full font-bold font-lato bg-gradient-to-tl from-white/50 via-black/5 to-white/50 bg-[#E64435] hover:text-white font-base py-5 px-[20px] relative uppercase rounded-xl transition ease-in-out duration-200 hover:scale-105">
                    REGISTER ON ROOBET.COM
                  </button>
                </a>
              </div>
            </div>
            </div>
            <div v-motion-pop-visible class="w-full lg:w-[55%] shadow-red-600 shadow-2xl rounded-2xl">
            <div class="roobet-big-bg h-[320px] md:h-[400px] rounded-2xl">
                <div class="absolute bottom-0 left-0 px-5 pb-5">
                    <div class="flex flex-col justify-start gap-3">
                        <div class="flex flex-col md:flex-row items-center gap-3">
                            <div class="text-white font-lato font-extrabold text-2xl uppercase tracking-widest">Use Code on</div>
                            <img src="../assets/roobet-logo.png" class="w-[150px]">
                        </div>
                        <div>
                            <span class="font-black font-montserrat text-[#FC9A0E] text-6xl">CHILIPIE</span>
                        </div>
                        <!-- <div>
                            <p class="text-white text-center md:text-left font-lato tracking-widest">To receive 100% deposit bonus upon registration</p>
                        </div> -->
                    </div>
                </div>
            </div>
            </div>
            <div v-motion-pop-visible class="w-full lg:w-[55%] shadow-red-600 shadow-2xl rounded-2xl">
            <div class="packdraw-big-bg h-[320px] md:h-[400px] rounded-2xl">
                <div class="absolute bottom-0 left-0 px-5 pb-5">
                    <div class="flex flex-col justify-start gap-3">
                        <div class="flex flex-col md:flex-row items-center gap-3">
                            <div class="text-white font-lato font-extrabold text-2xl uppercase tracking-widest">Use Code on</div>
                            <img src="../assets/packdraw-logo.png" class="w-[200px]">
                        </div>
                        <div>
                            <span class="font-black font-montserrat text-[#E64435] text-6xl">CHILI</span>
                        </div>
                        <!-- <div>
                            <p class="text-white text-center md:text-left font-lato tracking-widest">To receive 100% deposit bonus upon registration</p>
                        </div> -->
                    </div>
                </div>
            </div>
            </div>
            <div v-motion-pop-visible class="w-full md:w-[48%] lg:w-[30%] shadow-red-600 shadow-2xl rounded-2xl">
            <div class="relative packdraw-small-bg h-[320px] md:h-[400px] rounded-2xl">
              <div class="absolute bottom-0 w-full px-6 pb-6">
                <a href="https://t.co/icBPl1Ctwr" target="_blank">
                  <button class="text-white w-full font-bold font-lato bg-gradient-to-tl from-white/50 via-black/5 to-white/50 bg-[#E64435] hover:text-white font-base py-5 px-[12px] relative uppercase rounded-xl transition ease-in-out duration-200 hover:scale-105">
                    REGISTER ON Packdraw.com
                  </button>
                </a>
              </div>
            </div>
            </div>
        </div>
      </section>
    </section>

    <!-- Socials Section -->
    <section class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] pt-24 pb-40 socials-bg bg-cover lg:bg-contain bg-left lg:bg-center" id="socials">
      <div class="flex flex-col justify-center items-center font-montserrat">
        <p v-motion-pop-visible class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-3xl md:text-4xl uppercase">FOLLOW ME ON MY SOCIALS</p>
      </div>
      <div class="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-14 mt-20" style="font-family: Oxanium, sans-serif;">
        <a href="https://www.youtube.com/@ChiliSlots" target="_blank">
          <div v-motion-pop-visible class="flex flex-col justify-center items-center gap-3 border rounded-xl p-10 shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/40 via-transparent to-white/40 hover:bg-[#E64435] border-[#E64435]">
                <img src="../assets/youtube.png" alt="">
          </div>
        </a>
        <a href="https://x.com/ChiliSlots" target="_blank">
          <div v-motion-pop-visible class="flex flex-col justify-center items-center gap-3 border rounded-xl p-10 shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/40 via-transparent to-white/40 hover:bg-[#E64435] border-[#E64435]">
                <img src="../assets/twitter.png" alt="">
          </div>
        </a>
        <a href="https://discord.gg/raHVRc9Tag" target="_blank">
          <div v-motion-pop-visible class="flex flex-col justify-center items-center gap-3 border rounded-xl p-10 shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/40 via-transparent to-white/40 hover:bg-[#E64435] border-[#E64435]">
                <img src="../assets/discord.png" alt="">
          </div>
        </a>
        <a href="https://www.kick.com/Chilislots" target="_blank">
          <div v-motion-pop-visible class="flex flex-col justify-center items-center gap-3 border rounded-xl p-10 shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/40 via-transparent to-white/40 hover:bg-[#E64435] border-[#E64435]">
                <img src="../assets/kick.png" alt="">
          </div>
        </a>
      </div>
    </section>

    <section class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] py-20 lg:py-20 leaderboard-bg" id="leaderboards">
      <div class="flex flex-col justify-center items-center font-montserrat">
          <p v-motion-pop-visible class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-3xl md:text-4xl uppercase">Leaderboard</p>
      </div>
      <div class="flex justify-center items-center flex-col md:flex-row gap-4 mt-10 px-8 font-lato">
          <button v-motion-slide-visible-right :disabled="loading == true" @click="activeTab = 'roobet';" :class="{'bg-[#E64435] border-[#E64435]': activeTab == 'roobet'}" class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border hover:border-[#E64435] hover:text-white font-base py-3 px-8 md:px-10 relative uppercase rounded-xl">
            <img src="../assets/roobet-logo.png" class="w-[150px]">
          </button>
          <button v-motion-slide-visible-left :disabled="loading == true" @click="activeTab = 'packdraw';" :class="{'bg-[#E64435] border-[#E64435]': activeTab == 'packdraw'}" class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border hover:border-[#E64435] hover:text-white font-base py-[11px] px-8 md:px-9 relative uppercase rounded-xl">
            <img src="../assets/packdraw-logo.png" class="w-[150px]">
          </button>
          <button v-motion-slide-visible-left :disabled="loading == true" @click="activeTab = 'raingg';" :class="{'bg-[#E64435] border-[#E64435]': activeTab == 'raingg'}" class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border hover:border-[#E64435] hover:text-white font-base py-[11px] px-8 md:px-9 relative uppercase rounded-xl">
            <img src="../assets/raingg.webp" class="w-[150px]">
          </button>
      </div>
      <div v-if="activeTab == 'roobet'">
          <RoobetLeaderboardSection/>
      </div>
      <div v-if="activeTab == 'packdraw'">
          <PackdrawLeaderboardSection/>
      </div>
      <div v-if="activeTab == 'raingg'">
          <RainGGLeaderboardSection/>
      </div>
    </section>
  </div>
</template>

<script>
import PackdrawLeaderboardSection from "@/sections/PackdrawLeaderboardSection.vue";
import RoobetLeaderboardSection from "@/sections/RoobetLeaderboardSection.vue";
import RainGGLeaderboardSection from "@/sections/RainGGLeaderboardSection.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    RoobetLeaderboardSection,
    PackdrawLeaderboardSection,
    RainGGLeaderboardSection
  },
  data() {
    return {
      loading: false,
      activeTab: 'roobet'
    };
  },
  methods: {
    isMobile() {
      return window.innerWidth < 1024;
    },
  }
});
</script>

<style scope>


.main-btn:hover .main-span {
  border-color: #1294F0;
}

.leaderboard-bg {
  background-image: url("../assets/leaderboard-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
}

.socials-bg {
  background-image: url("../assets/socials-bg.png");
  background-repeat: no-repeat;
}

.promotion-frame-bg {
  background-image: url('../assets/promotion-frame-bg.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.promotion-frame-mobile-bg {
  background-image: url('../assets/promotion-frame-mobile-bg.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.hero-bg {
  background-image: url("../assets/main-page-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}

.roobet-big-bg {
  background-image: url("../assets/roobet-big-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.roobet-small-bg {
  background-image: url("../assets/roobet-small-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.packdraw-big-bg {
  background-image: url("../assets/packdraw-big-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.packdraw-small-bg {
  background-image: url("../assets/packdraw-small-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
